import styled from 'styled-components';

import { Text } from '@/nova/components';
import { hoverWash } from '@/nova/theme/mixins';
import { ANIM, COLORS, MOBILE } from '@/nova/theme/tokens';

export const Body = styled(Text)`
  font-size: 14px;
  line-height: 1.5;
  color: ${COLORS.featureName};
`;

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;

  ${MOBILE} {
    flex-direction: column-reverse;
    align-items: stretch;
  }
`;

/** Solid destructive confirm CTA. Self-contained styled button (not the shared
 *  Button, which has no danger variant) so it renders correctly inside the
 *  Overlay's footer slot, which sits outside the page's scoped styles. */
export const DangerButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 20px;
  border: none;
  border-radius: 9999px;
  background: ${COLORS.statusDanger};
  color: ${COLORS.onAccent};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity ${ANIM.INTERACT_MS}ms ease;

  /* Cursor-following hover glow + lit hairline ring (shared with the CTA Button). */
  ${hoverWash}

  &:hover {
    opacity: 0.88;
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }

  &:disabled:hover::before,
  &:disabled:hover::after,
  &:disabled:focus-visible::before,
  &:disabled:focus-visible::after {
    opacity: 0;
  }
`;
